import React, { Component } from "react";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";

class BankDetails extends Component {
  render() {
    const { formRef, isDisabled } = this.props;
    return (
      <div className="row form-box">
        <legend className="form-legend">Bank Details</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="bank_name"
            id="bank_name"
            required={false}
            disabled={isDisabled}
            label="Bank Name"
            message="Enter Bank Name"
            placeholder="Enter Bank Name"
            validators=""
            formRef={formRef}
            maxLength={50}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="bank_account_number"
            id="bank_account_number"
            required={false}
            disabled={isDisabled}
            label="Bank Account Number"
            message="Enter Bank Account Number"
            placeholder="Enter Bank Account Number"
            validators=""
            formRef={formRef}
            maxLength={30}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="bank_holder_name"
            id="bank_holder_name"
            required={false}
            disabled={isDisabled}
            label="Bank Holder Name"
            message="Enter Bank Holder Name"
            placeholder="Enter Bank Holder Name"
            validators=""
            formRef={formRef}
            maxLength={50}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="bank_ifsc_code"
            id="bank_ifsc_code"
            required={false}
            disabled={isDisabled}
            label="Bank IFSC Code"
            message="Enter Bank IFSC Code"
            placeholder="Enter Bank IFSC Code"
            validators=""
            formRef={formRef}
            maxLength={20}
          />
        </div>
      </div>
    );
  }
}

export default BankDetails;
